import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "flex flex-col" }
const _hoisted_2 = { class: "oaiCriticalPathGraphNodeHoverItem border-b" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_4 = {
  class: "text-white rounded-lg px-2 py-0.5 truncate w-min max-w-full",
  style: { backgroundColor: '#bccfcc' }
}
const _hoisted_5 = { class: "text-white rounded-lg px-2 py-0.5 truncate w-min bg-blue-600 max-w-full" }
const _hoisted_6 = {
  key: 0,
  class: "oaiCriticalPathGraphNodeHoverItem font-semibold"
}
const _hoisted_7 = { class: "py-0.5" }
const _hoisted_8 = { class: "py-0.5" }
const _hoisted_9 = { class: "py-0.5" }
const _hoisted_10 = {
  key: 1,
  class: "flex flex-col w-[80%] mr-6 self-end"
}
const _hoisted_11 = { class: "flex-1 flex flex-col items-center gap-1 border-t border-l border-r text-center p-2" }
const _hoisted_12 = { class: "mt-4 text-base font-semibold" }
const _hoisted_13 = { class: "flex gap-[180px]" }
const _hoisted_14 = { class: "flex" }
const _hoisted_15 = { class: "w-[100px] truncate" }
const _hoisted_16 = { class: "flex" }
const _hoisted_17 = { class: "w-[100px] truncate pr-2" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "w-[15px]" }, null, -1)
const _hoisted_19 = { class: "flex-1 text-right" }
const _hoisted_20 = { class: "flex" }
const _hoisted_21 = { class: "w-[100px] truncate pr-2" }
const _hoisted_22 = { class: "capitalize" }
const _hoisted_23 = { class: "w-[15px]" }
const _hoisted_24 = { class: "flex-1 text-right" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "w-[100px]" }, null, -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { class: "w-[15px]" }, "=", -1)
const _hoisted_27 = { class: "flex-1 text-right" }
const _hoisted_28 = {
  key: 2,
  class: "flex flex-col w-[80%] mr-6 self-end"
}
const _hoisted_29 = { class: "flex-1 flex flex-col items-center gap-1 border-t border-l border-r text-center p-2" }
const _hoisted_30 = { class: "mt-4 text-base font-semibold" }
const _hoisted_31 = { class: "flex gap-[180px]" }
const _hoisted_32 = { class: "flex" }
const _hoisted_33 = { class: "flex" }
const _hoisted_34 = { class: "w-[100px] truncate pr-2" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("div", { class: "w-[15px]" }, null, -1)
const _hoisted_36 = { class: "flex-1 text-right" }
const _hoisted_37 = { class: "flex" }
const _hoisted_38 = { class: "w-[100px] truncate pr-2" }
const _hoisted_39 = { class: "capitalize" }
const _hoisted_40 = { class: "w-[15px]" }
const _hoisted_41 = { class: "flex-1 text-right" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("div", { class: "w-[100px]" }, null, -1)
const _hoisted_43 = /*#__PURE__*/_createElementVNode("div", { class: "w-[15px]" }, "=", -1)
const _hoisted_44 = { class: "flex-1 text-right" }
const _hoisted_45 = { class: "flex" }
const _hoisted_46 = { class: "w-[100px] truncate pr-2" }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("div", { class: "w-[15px]" }, null, -1)
const _hoisted_48 = { class: "flex-1 text-right" }
const _hoisted_49 = { class: "flex" }
const _hoisted_50 = { class: "w-[100px] truncate pr-2" }
const _hoisted_51 = { class: "w-[15px]" }
const _hoisted_52 = /*#__PURE__*/_createElementVNode("div", { class: "w-[100px]" }, null, -1)
const _hoisted_53 = /*#__PURE__*/_createElementVNode("div", { class: "w-[15px]" }, "=", -1)
const _hoisted_54 = { class: "flex-1 text-right" }

import { ArrowUpIcon, ArrowUpLeftIcon, ArrowUpRightIcon } from "@heroicons/vue/24/outline";
import { format, isSameDay } from "date-fns";
import { computed } from "vue";
import { useI18n } from "vue-i18n";
import { CriticalPathDelta, CriticalPathNodeEx } from "shared/types/CriticalPath";
import {
  useDeltaTextClass,
  useDeltaTextWithBackgroundClass,
  useFormattedDelta,
} from "../composables";

const dateFormat = "dd.MM.yyyy";


export default /*#__PURE__*/_defineComponent({
  __name: 'CriticalPathGraphNodeHoverNotFinishedSummary',
  props: {
    criticalPathNode: {},
    deltaForNode: {}
  },
  setup(__props: any) {

const props = __props;

const { t } = useI18n();

const now = new Date();

const delta = computed(() => props.deltaForNode.workingDays);
const differenceWithBackgroundClass = useDeltaTextWithBackgroundClass(delta);
const formattedDelta = useFormattedDelta(delta);

const formatDate = (date: Date | null | undefined) => {
  if (!date) {
    return "-";
  }
  return format(date, dateFormat);
};

const isProjectedEndToday = computed(
  () => props.deltaForNode.projectedEndDate && isSameDay(props.deltaForNode.projectedEndDate, now),
);

const isProjectedEndActualStartPlusPlannedWorkingDaysDate = computed(
  () =>
    props.deltaForNode.projectedEndDate &&
    props.deltaForNode.actualStartPlusPlannedWorkingDaysDate &&
    isSameDay(
      props.deltaForNode.projectedEndDate,
      props.deltaForNode.actualStartPlusPlannedWorkingDaysDate,
    ),
);

const isProjectedEndNowPlusPlannedWorkingDaysDate = computed(
  () =>
    props.deltaForNode.projectedEndDate &&
    props.deltaForNode.nowPlusPlannedWorkingDaysDate &&
    isSameDay(
      props.deltaForNode.projectedEndDate,
      props.deltaForNode.nowPlusPlannedWorkingDaysDate,
    ),
);

const isProjectedEndPlannedEndPlusPreviousDeltaDate = computed(
  () =>
    props.deltaForNode.projectedEndDate &&
    props.deltaForNode.plannedEndPlusPreviousDeltaDate &&
    isSameDay(
      props.deltaForNode.projectedEndDate,
      props.deltaForNode.plannedEndPlusPreviousDeltaDate,
    ),
);

const getAbs = (number: number | null) => (number !== null ? Math.abs(number) : "-");

const getSign = (number: number | null) => {
  if (number === null) {
    return "";
  }
  if (number < 0) {
    return "-";
  }
  return "+";
};

const getInvertedSign = (number: number | null) => {
  if (number === null) {
    return "";
  }
  return getSign(-number);
};

const previousNodeDeltaClass = useDeltaTextClass(
  computed(() => props.deltaForNode?.previousNodeDelta?.workingDays ?? null),
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(t)("analytics.critical_path.planned_end")), 1),
      _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(t)("analytics.critical_path.projected_end_abbreviated")), 1),
      _createElementVNode("div", null, _toDisplayString(_unref(t)("analytics.critical_path.working_days")), 1)
    ]),
    (_ctx.deltaForNode.plannedEvent && _ctx.deltaForNode.projectedEndDate)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, _toDisplayString(_unref(t)("time.all_time")), 1),
          _createElementVNode("div", _hoisted_8, _toDisplayString(_unref(format)(_ctx.deltaForNode.plannedEvent.end, dateFormat)), 1),
          _createElementVNode("div", _hoisted_9, _toDisplayString(_unref(format)(_ctx.deltaForNode.projectedEndDate, dateFormat)), 1),
          _createElementVNode("div", {
            class: _normalizeClass(["w-min rounded-full px-2 py-0.5 whitespace-nowrap", _unref(differenceWithBackgroundClass)])
          }, _toDisplayString(_unref(formattedDelta)), 3)
        ]))
      : _createCommentVNode("", true),
    (_ctx.criticalPathNode.state === 'in_progress')
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _createVNode(_unref(ArrowUpIcon), { class: "w-6 h-6 bg-white self-center -mb-[8px] z-[100]" }),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, _toDisplayString(_unref(t)("analytics.critical_path.max_from")), 1),
            _createElementVNode("div", _hoisted_13, [
              _createVNode(_unref(ArrowUpRightIcon), {
                class: _normalizeClass(["w-6 h-6", isProjectedEndToday.value ? 'text-gray-600' : 'text-gray-400'])
              }, null, 8, ["class"]),
              _createVNode(_unref(ArrowUpLeftIcon), {
                class: _normalizeClass(["w-6 h-6", 
              isProjectedEndActualStartPlusPlannedWorkingDaysDate.value
                ? 'text-gray-600'
                : 'text-gray-400'
            ])
              }, null, 8, ["class"])
            ])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", {
              class: _normalizeClass(["border-t border-l border-b p-4 flex-1 flex items-end", isProjectedEndToday.value ? 'text-gray-600' : 'text-gray-400'])
            }, [
              _createElementVNode("div", _hoisted_15, _toDisplayString(_unref(t)("calendar.today")) + ":", 1),
              _createElementVNode("div", {
                class: _normalizeClass([isProjectedEndToday.value ? 'font-semibold' : '', "text-right flex-1"])
              }, _toDisplayString(_unref(format)(_unref(now), dateFormat)), 3)
            ], 2),
            _createElementVNode("div", {
              class: _normalizeClass(["flex flex-col gap-2 border p-4 flex-1", 
            isProjectedEndActualStartPlusPlannedWorkingDaysDate.value ? 'text-gray-600' : 'text-gray-400'
          ])
            }, [
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, _toDisplayString(_unref(t)("analytics.critical_path.actual_start")) + ": ", 1),
                _hoisted_18,
                _createElementVNode("div", _hoisted_19, _toDisplayString(formatDate(_ctx.deltaForNode.actualStart)), 1)
              ]),
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("span", _hoisted_22, _toDisplayString(_unref(t)("analytics.planner.planned_event_name")), 1),
                  _createTextVNode(" " + _toDisplayString(_unref(t)("working_day.working_day_abbrev")) + ": ", 1)
                ]),
                _createElementVNode("div", _hoisted_23, _toDisplayString(getSign(_ctx.deltaForNode.plannedWorkingDays)), 1),
                _createElementVNode("div", _hoisted_24, _toDisplayString(getAbs(_ctx.deltaForNode.plannedWorkingDays)) + " " + _toDisplayString(_unref(t)("working_day.working_day_abbrev")), 1)
              ]),
              _createElementVNode("div", {
                class: _normalizeClass(["flex border-t pt-2", isProjectedEndActualStartPlusPlannedWorkingDaysDate.value ? 'font-semibold' : ''])
              }, [
                _hoisted_25,
                _hoisted_26,
                _createElementVNode("div", _hoisted_27, _toDisplayString(formatDate(_ctx.deltaForNode.actualStartPlusPlannedWorkingDaysDate)), 1)
              ], 2)
            ], 2)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.criticalPathNode.state === 'not_started')
      ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
          _createVNode(_unref(ArrowUpIcon), { class: "w-6 h-6 bg-white self-center -mb-[8px] z-[100]" }),
          _createElementVNode("div", _hoisted_29, [
            _createElementVNode("div", _hoisted_30, _toDisplayString(_unref(t)("analytics.critical_path.max_from")), 1),
            _createElementVNode("div", _hoisted_31, [
              _createVNode(_unref(ArrowUpRightIcon), {
                class: _normalizeClass(["w-6 h-6", isProjectedEndNowPlusPlannedWorkingDaysDate.value ? 'text-gray-600' : 'text-gray-400'])
              }, null, 8, ["class"]),
              _createVNode(_unref(ArrowUpLeftIcon), {
                class: _normalizeClass(["w-6 h-6", 
              isProjectedEndPlannedEndPlusPreviousDeltaDate.value ? 'text-gray-600' : 'text-gray-400'
            ])
              }, null, 8, ["class"])
            ])
          ]),
          _createElementVNode("div", _hoisted_32, [
            _createElementVNode("div", {
              class: _normalizeClass(["flex flex-col gap-2 border-l border-b border-t p-4 flex-1", isProjectedEndNowPlusPlannedWorkingDaysDate.value ? 'text-gray-600' : 'text-gray-400'])
            }, [
              _createElementVNode("div", _hoisted_33, [
                _createElementVNode("div", _hoisted_34, _toDisplayString(_unref(t)("calendar.today")) + ":", 1),
                _hoisted_35,
                _createElementVNode("div", _hoisted_36, _toDisplayString(formatDate(_unref(now))), 1)
              ]),
              _createElementVNode("div", _hoisted_37, [
                _createElementVNode("div", _hoisted_38, [
                  _createElementVNode("span", _hoisted_39, _toDisplayString(_unref(t)("analytics.planner.planned_event_name")), 1),
                  _createTextVNode(" " + _toDisplayString(_unref(t)("working_day.working_day_abbrev")) + ": ", 1)
                ]),
                _createElementVNode("div", _hoisted_40, _toDisplayString(getSign(_ctx.deltaForNode.plannedWorkingDays)), 1),
                _createElementVNode("div", _hoisted_41, _toDisplayString(getAbs(_ctx.deltaForNode.plannedWorkingDays)) + " " + _toDisplayString(_unref(t)("working_day.working_day_abbrev")), 1)
              ]),
              _createElementVNode("div", {
                class: _normalizeClass(["flex border-t pt-2", isProjectedEndNowPlusPlannedWorkingDaysDate.value ? 'font-semibold' : ''])
              }, [
                _hoisted_42,
                _hoisted_43,
                _createElementVNode("div", _hoisted_44, _toDisplayString(formatDate(_ctx.deltaForNode.nowPlusPlannedWorkingDaysDate)), 1)
              ], 2)
            ], 2),
            _createElementVNode("div", {
              class: _normalizeClass(["flex flex-col gap-2 border p-4 flex-1", isProjectedEndPlannedEndPlusPreviousDeltaDate.value ? 'text-gray-600' : 'text-gray-400'])
            }, [
              _createElementVNode("div", _hoisted_45, [
                _createElementVNode("div", _hoisted_46, _toDisplayString(_unref(t)("analytics.critical_path.planned_end")) + ": ", 1),
                _hoisted_47,
                _createElementVNode("div", _hoisted_48, _toDisplayString(formatDate(_ctx.deltaForNode.plannedEvent?.end)), 1)
              ]),
              _createElementVNode("div", _hoisted_49, [
                _createElementVNode("div", _hoisted_50, _toDisplayString(_unref(t)("analytics.critical_path.previous_delta")) + ": ", 1),
                _createElementVNode("div", _hoisted_51, _toDisplayString(getInvertedSign(_ctx.deltaForNode.previousNodeDelta?.workingDays ?? null)), 1),
                _createElementVNode("div", {
                  class: _normalizeClass([_unref(previousNodeDeltaClass), "flex-1 text-right"])
                }, _toDisplayString(getAbs(_ctx.deltaForNode.previousNodeDelta?.workingDays ?? null)) + " " + _toDisplayString(_unref(t)("working_day.working_day_abbrev")), 3)
              ]),
              _createElementVNode("div", {
                class: _normalizeClass(["flex border-t pt-2", isProjectedEndPlannedEndPlusPreviousDeltaDate.value ? 'font-semibold' : ''])
              }, [
                _hoisted_52,
                _hoisted_53,
                _createElementVNode("div", _hoisted_54, _toDisplayString(formatDate(_ctx.deltaForNode.plannedEndPlusPreviousDeltaDate)), 1)
              ], 2)
            ], 2)
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})